// Mirrors the model pickers: models the user lacks permission for stay listed (upsell) unless flagged hide_unauthorized.
const getVisibleInferenceModels = (inferenceModels, permissions) => (inferenceModels ?? []).filter((model) => !model.permission || !model.hide_unauthorized || Boolean(permissions?.includes(model.permission)));
export default getVisibleInferenceModels;
